import { render, staticRenderFns } from "./paid_session_result.vue?vue&type=template&id=4b744d61&"
import script from "./paid_session_result.vue?vue&type=script&lang=js&"
export * from "./paid_session_result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports